export default __webpack_public_path__ + "static/MediaContentFive-e2fafc67870eb81d476a112afdf9971b.webp";